'use client'

import { useCheckout, usePaymentMethodDiscount } from '@/lib/hooks'
import { setPaymentMethodType } from '@/lib/redux'
import React, { use } from 'react'
import { toast } from 'sonner'

import { RefContext, type Refs } from '@/components/providers/ref-provider'
import { InputForm } from '@/components/ui'

interface CustomReferenceProps extends React.ComponentPropsWithoutRef<'form'> {
  onClose: () => void
}

export const CustomReference = ({ onClose }: CustomReferenceProps) => {
  const [isPending, startTransition] = React.useTransition()
  const { amountInputRef } = use(RefContext) as Refs
  const { payment_method, setCurrentStep, setCustomReference, queryParams } =
    useCheckout()
  const { applyPaymentMethodDiscount } = usePaymentMethodDiscount()

  const handleSubmit = (data: FormData) => {
    const reference = data.get('custom-reference') as string

    startTransition(async () => {
      try {
        setCustomReference(reference)
        setPaymentMethodType(
          payment_method?.name ?? payment_method?.group ?? 'other',
        )

        // // Always call API to remove old discounts and apply new ones (if any)
        // if (queryParams?.cartId && payment_method?.discount?.[0]?.discount) {
        //   try {
        //     await applyPaymentMethodDiscount({
        //       cartId: queryParams.cartId,
        //       paymentMethod: payment_method,
        //     })
        //   } catch (error) {
        //     console.error('Failed to apply/remove discount:', error)
        //     // Continue even if discount operation fails
        //   }
        // }

        setCurrentStep('COLLECT_PAYMENT')
        amountInputRef?.current?.focus()
        onClose?.()
      } catch (error: any) {
        if (typeof error === 'string') {
          toast.error(error)
          return
        }

        toast.error(error?.message)
        return
      }
    })
  }

  return (
    <form className="flex w-full flex-col gap-3 pt-2" action={handleSubmit}>
      <InputForm
        name="custom-reference"
        type="text"
        noSearch
        placeholder={payment_method?.reference_label ?? 'Custom Reference'}
        className="pl-5"
        submitLabel="Submit"
        submitPendingLabel="Saving..."
        disabled={isPending}
      />
    </form>
  )
}
